import {
  RECEIVED_RPS_SUBSCRIPTION_INFORMATION,
  RECEIVED_UPDATE_RPS_SUBSCRIPTION
} from './LinkRpsAccountsActions';
import { isNil } from 'lodash';

export const rpsSubscriptionInfoInitialState = {};

export const rpsSubscriptionInformationReducer = (
  state = rpsSubscriptionInfoInitialState,
  action
) => {
  if (action.type === RECEIVED_RPS_SUBSCRIPTION_INFORMATION) {
    const { eligible, subscribed } = action.payload;

    if (!isNil(eligible) && !isNil(subscribed)) {
      return {
        eligible: eligible,
        subscribed: subscribed
      };
    }
    return state;
  }
  if (action.type === RECEIVED_UPDATE_RPS_SUBSCRIPTION) {
    const { subscribed } = action.payload;

    if (!isNil(subscribed)) {
      return {
        ...state,
        subscribed: subscribed
      };
    }
    return state;
  }
  return state;
};
